import {
  batteryConcertErrorCode,
  batteryConcertErrorMessage,
  BATTERY_FINANCING_LOCKED_MESSAGE,
  CONCERT_REFRESH_PRICING_REQUIRED_MESSAGE,
} from "~/api/battery-concert-application-errors"
import { isRefreshPaymentRequiredError } from "~/api/battery-financing-errors"
import useBatteryConcertApplication from "~/api/hooks/useBatteryConcertApplication"
import useGenerateBatteryConcertLoanDocuments from "~/api/hooks/useGenerateBatteryConcertLoanDocuments"
import useInitiateBatteryConcertApplication from "~/api/hooks/useInitiateBatteryConcertApplication"
import useSendBatteryConcertLoanDocuments from "~/api/hooks/useSendBatteryConcertLoanDocuments"
import useSubmitBatteryConcertApplication from "~/api/hooks/useSubmitBatteryConcertApplication"
import useSubmitBatteryConcertDocuments from "~/api/hooks/useSubmitBatteryConcertDocuments"
import useUploadBatteryConcertDocument from "~/api/hooks/useUploadBatteryConcertDocument"

import {
  CONCERT_SETUP_FAILED_STATUS_MESSAGE,
  CONCERT_SETUP_UNCONFIRMED_STATUS_MESSAGE,
  NO_CONCERT_APPLICATION_MESSAGE,
  SUPPORTING_DOCUMENT_ACTIONS_ENABLED,
} from "./concert-battery-copy"
import { ConcertBatterySupplementalDocuments } from "./ConcertBatterySupplementalDocuments"
import type { ConcertApplicationBundle } from "../../../ProposalSetup/financing/concert/concert-kind-bundle"
import { CONCERT_SUBMIT_FAILED_MESSAGE } from "../../../ProposalSetup/financing/concert/ConcertApplicationForm"
import { RefreshPricingAction } from "../../refresh-pricing-action"

export const CONCERT_SETUP_REQUIRED_MESSAGE = `Customer setup is required. Close this form and use Reserve now again.`

const describeSubmitError = (error: unknown): string => {
  if (isRefreshPaymentRequiredError(error)) {
    return CONCERT_REFRESH_PRICING_REQUIRED_MESSAGE
  }
  switch (batteryConcertErrorCode(error)) {
    case `BATTERY_FINANCING_LOCKED`:
      return BATTERY_FINANCING_LOCKED_MESSAGE
    case `CONCERT_SETUP_REQUIRED`:
      return CONCERT_SETUP_REQUIRED_MESSAGE
    default:
      return batteryConcertErrorMessage(error) ?? CONCERT_SUBMIT_FAILED_MESSAGE
  }
}

/** Battery-Only Proposal commands and copy for the shared Concert application pieces. */
export const batteryConcertApplicationBundle: ConcertApplicationBundle = {
  testIdPrefix: `battery`,
  useStatus: useBatteryConcertApplication,
  useInitiate: useInitiateBatteryConcertApplication,
  useSubmit: useSubmitBatteryConcertApplication,
  useUpload: useUploadBatteryConcertDocument,
  useSubmitDocuments: useSubmitBatteryConcertDocuments,
  useGenerateLoanDocuments: useGenerateBatteryConcertLoanDocuments,
  useSendLoanDocuments: useSendBatteryConcertLoanDocuments,
  // Battery sends Concert's loan documents by email only.
  inPersonLoanDocuments: false,
  supportingDocumentActions: SUPPORTING_DOCUMENT_ACTIONS_ENABLED,
  Supplemental: ConcertBatterySupplementalDocuments,
  isRefreshRequiredError: isRefreshPaymentRequiredError,
  RefreshPricing: RefreshPricingAction,
  describeSubmitError,
  copy: {
    offerNoun: `Battery`,
    noApplication: NO_CONCERT_APPLICATION_MESSAGE,
    setupFailed: CONCERT_SETUP_FAILED_STATUS_MESSAGE,
    setupUnconfirmed: CONCERT_SETUP_UNCONFIRMED_STATUS_MESSAGE,
  },
}
